import {Injectable} from '@angular/core';
import {LandlordPropertyModel} from "@core/model/landlordProperty.model";
import {ConsoleAuthenticationService} from "@security/console-authentication.service";
import {ConsoleContextService} from "@security/console-context.service";
import {SessionKey} from "@ui-kit/framework/security/model/session-key.enum";
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class PrintListenerService {
  private headersSubject = new BehaviorSubject<any>(null);
  public headers$ = this.headersSubject.asObservable();

  constructor(private auth: ConsoleAuthenticationService,
              private context: ConsoleContextService) {
    // Listen for the custom event
    // this is so we know when the headers have been injected
    window.addEventListener('headersInjected', (event: Event) => {
      const customEvent = event as CustomEvent;
      console.log('Headers service received!');
      this.setHeaderContext(customEvent.detail.headers);
      this.headersSubject.next(customEvent.detail.headers);
    });
  }

  private setHeaderContext(headers: any) {
    const token = headers.authorization;

    if (token) {
      sessionStorage.setItem(SessionKey.TOKEN_KEY, token.replace('Bearer ', ''))
    } else {
      this.auth.logout();
    }

    sessionStorage.setItem(SessionKey.CURRENT_LANDLORD_ID, headers['x-landlord-id'])
    const location = new LandlordPropertyModel();

    location.uuid = headers['x-location-id'];
    this.context.setCurrentLocation(location)

    const offeringId = headers['x-offering-id'];
    this.context.setCurrentOfferingId(offeringId);
  }
}
